module.exports = __webpack_public_path__ + "img/japan-cerebrovascular-disease-female.743ca140.png";